import { render, staticRenderFns } from "./Governance.vue?vue&type=template&id=573352de&scoped=true"
import script from "./Governance.vue?vue&type=script&lang=js"
export * from "./Governance.vue?vue&type=script&lang=js"
import style0 from "./Governance.vue?vue&type=style&index=0&id=573352de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573352de",
  null
  
)

export default component.exports